import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRectangleList, faUserTie } from "@fortawesome/pro-regular-svg-icons";
import { FormInput, FormSelect, FormDate } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
/** Editable task fields (title, type, owner, due date) shared by the create and modify states. */
export function TaskActionFields(_ref) {
  var actionId = _ref.actionId,
    title = _ref.title,
    labelId = _ref.labelId,
    ownedBy = _ref.ownedBy,
    dueDate = _ref.dueDate,
    labelOptions = _ref.labelOptions,
    ownerOptions = _ref.ownerOptions,
    onTitleChange = _ref.onTitleChange,
    onLabelChange = _ref.onLabelChange,
    onOwnerChange = _ref.onOwnerChange,
    onDueDateChange = _ref.onDueDateChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-3 pt-3 pb-2"
  }, /*#__PURE__*/React.createElement(FormInput, {
    "data-testid": "task-action-title-".concat(actionId),
    value: title,
    onChange: function onChange(e) {
      return onTitleChange(e.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.TASK_ACTION_TITLE, {
        actionId: actionId
      });
    },
    placeholder: "".concat(t("placeholder.task_title", {
      defaultValue: "Task title"
    }), "*"),
    styles: {
      input: {
        fontWeight: 600
      }
    },
    classNames: {
      root: "w-full"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-2 flex items-center gap-2"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    "data-testid": "task-action-label-".concat(actionId),
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faRectangleList,
      className: "w-3.5 h-3.5"
    }),
    placeholder: t("label.select_task_type", {
      defaultValue: "Select task type"
    }),
    data: labelOptions,
    value: labelId,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.TASK_ACTION_LABEL, {
        actionId: actionId
      });
      onLabelChange(value);
    },
    clearable: true,
    classNames: {
      root: "flex-1 min-w-0"
    }
  }), /*#__PURE__*/React.createElement(FormSelect, {
    "data-testid": "task-action-owner-".concat(actionId),
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserTie,
      className: "w-3.5 h-3.5"
    }),
    placeholder: "".concat(t("label.task_owner", {
      defaultValue: "Task owner"
    }), "*"),
    data: ownerOptions,
    value: ownedBy,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.TASK_ACTION_OWNER, {
        actionId: actionId
      });
      onOwnerChange(value);
    },
    searchable: true,
    clearable: true,
    classNames: {
      root: "flex-1 min-w-0"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 min-w-0"
  }, /*#__PURE__*/React.createElement(FormDate, {
    value: dueDate,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.TASK_ACTION_DATE, {
        actionId: actionId
      });
      onDueDateChange(value);
    },
    testId: "task-action-date-".concat(actionId),
    highlightToday: true
  }))));
}